import React from 'react';
import { ComposableMap, Geographies, Geography, Marker, ZoomableGroup, Graticule } from 'react-simple-maps';

// TopoJSON source for a simple world map
// Border-free land dataset (no country boundaries) from world-atlas
// This draws land masses only, avoiding country boundary issues
const geoUrl = "https://cdn.jsdelivr.net/npm/world-atlas@2/land-50m.json";

// Office coordinates [lng, lat]
const offices = [
  { name: 'Toronto, Canada', coords: [-79.3832, 43.6532], color: '#059669', align: 'right' },
  { name: 'Delhi NCR, India', coords: [77.1025, 28.7041], color: '#047857', align: 'right' },
  { name: 'Melbourne, Australia (Head Office)', coords: [144.9631, -37.8136], color: '#0F766E', align: 'left', head: true },
];

export default function OfficesMap() {
  return (
    <div className="relative bg-gradient-to-br from-gray-50 to-gray-100 rounded-xl border border-gray-200 overflow-hidden h-64 sm:h-72 md:h-80 lg:h-96">
      <ComposableMap projection="geoMercator" projectionConfig={{ scale: 160 }} style={{ width: '100%', height: '100%' }}>
        <ZoomableGroup center={[0, 12]}>
          {/* Subtle graticule for context on a flat (Mercator) map */}
          <Graticule stroke="#E5E7EB" strokeWidth={0.4} opacity={0.35} />
          <Geographies geography={geoUrl}>
            {({ geographies }) =>
              geographies.map((geo) => (
                <Geography
                  key={geo.rsmKey}
                  geography={geo}
                  style={{
                    default: { fill: '#E5E7EB', stroke: 'none', outline: 'none' },
                    hover: { fill: '#E9F5EC', outline: 'none' },
                    pressed: { fill: '#E9F5EC', outline: 'none' },
                  }}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              ))
            }
          </Geographies>

      {offices.map((o) => (
            <Marker key={o.name} coordinates={o.coords}>
              <g transform="translate(0,0)">
        <circle r={6} fill={o.color} stroke="#fff" strokeWidth={2} />
                {/* Label bubble */}
        {o.align === 'right' ? (
                  <>
          <line x1={7} y1={0} x2={26} y2={0} stroke={o.color} strokeWidth={2} />
          <rect x={26} y={-14} rx={6} ry={6} width={o.head ? 200 : 150} height={26} fill="#fff" stroke="#E5E7EB" />
          <text x={36} y={2.5} style={{ fontSize: 12.5, fill: '#374151', fontFamily: 'ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, Noto Sans, Helvetica Neue, Arial, \"Apple Color Emoji\", \"Segoe UI Emoji\"' }}>
                      {o.name}
                    </text>
                  </>
                ) : (
                  <>
          <line x1={-7} y1={0} x2={-26} y2={0} stroke={o.color} strokeWidth={2} />
          <rect x={o.head ? -236 : -168} y={-14} rx={6} ry={6} width={o.head ? 226 : 156} height={26} fill="#fff" stroke="#E5E7EB" />
          <text x={o.head ? -226 : -158} y={2.5} style={{ fontSize: 12.5, fill: '#374151', fontFamily: 'ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, Noto Sans, Helvetica Neue, Arial, \"Apple Color Emoji\", \"Segoe UI Emoji\"' }}>
                      {o.name}
                    </text>
                  </>
                )}
              </g>
            </Marker>
          ))}
        </ZoomableGroup>
      </ComposableMap>
    </div>
  );
}
